import { analyticsClient } from './analytics-client'
import type { AnalyticsEventName, AnalyticsEventProps } from './events'

/**
 * Reports a frontend event (FE-321); the catalog is in `events.ts`.
 *
 * Never throws: it is called right before bets and deposits are signed,
 * outside their error handling, and analytics must not break those.
 */
export const track = <N extends AnalyticsEventName>(
  name: N,
  props: AnalyticsEventProps[N]
) => {
  try {
    analyticsClient.track(name, props)
  } catch (error) {
    console.warn(`analytics: ${name} not tracked`, error)
  }
}
